import React, { ReactNode } from 'react'
import { ToastProvider } from 'react-toast-notifications'

import { ModalProvider } from '@hooks/use-modal'
import { AuthProvider } from './auth/auth-context'

interface ProvidersProps {
  children: ReactNode
}

export const Providers = ({ children }: ProvidersProps) => (
  <AuthProvider>
    <ToastProvider>
      <ModalProvider>{children}</ModalProvider>
    </ToastProvider>
  </AuthProvider>
)
